<template>
    <div class="container-fluid">
        <Breadcrumb title="IP & Domain History" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="col-xl-6 float-left pl-0 pr-xl-3 pr-0">
                    <div class="card">
                        <div class="card-body">
                            <form @submit.prevent="getIpHistory" class="form-horizontal form-material">
                                <br />
                                <div class="form-group">
                                    <label for="ip" class="mb-1">IP:</label>
                                    <input id="ip" v-model="ip" type="text" class="form-control">
                                    <div class="text-danger" v-if="$v.ip.$error">Error</div>
                                </div>
                                <div class="form-group text-center">
                                    <br />
                                    <div class="col-xs-12 p-b-5">
                                        <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light"
                                            v-show="!submitting">
                                            Get
                                        </button>
                                        <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light"
                                            disabled v-show="submitting">
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true"></span>
                                            . . .
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 float-left pl-0 pr-xl-3 pr-0">
                    <div class="card">
                        <div class="card-body">
                            <form @submit.prevent="getDomainNameHistory" class="form-horizontal form-material">
                                <br />
                                <div class="form-group">
                                    <label for="domainName" class="mb-1">Domain:</label>
                                    <input id="domainName" v-model="domainName" type="text" class="form-control">
                                    <div class="text-danger" v-if="$v.domainName.$error">Required</div>
                                </div>
                                <div class="form-group text-center">
                                    <br />
                                    <div class="col-xs-12 p-b-5">
                                        <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light"
                                            v-show="!submitting">
                                            Get
                                        </button>
                                        <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light"
                                            disabled v-show="submitting">
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true"></span>
                                            . . .
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="position: relative">
            <div class="col-12" v-if="history.length <= 0">
                <div class="card">
                    <div class="card-body">
                        Nothing to show.
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="history.length > 0">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <div>
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Relay ID</th>
                                                    <th>IP</th>
                                                    <th>Domain</th>
                                                    <th>Created At</th>
                                                    <th>Deleted At</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(relay, index) in history" :key="index">
                                                    <td class="align-middle">{{ relay.id }}</td>
                                                    <td class="align-middle">{{ relay.ip }}</td>
                                                    <td class="align-middle">{{ relay.smtpHost }}</td>
                                                    <td class="align-middle">{{ relay.createdAt ?
                                                        moment.utc(relay.createdAt.date).format('YYYY-MM-DD') : '---' }}
                                                    </td>
                                                    <td class="align-middle">{{ relay.deletedAt ?
                                                        moment.utc(relay.deletedAt.date).format('YYYY-MM-DD') : '---' }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ToolsService from "../services/ToolsService";
import Swal from 'sweetalert2'
import Breadcrumb from '../components/Breadcrumb';
import { ipAddress, required } from 'vuelidate/lib/validators';

export default {
    name: 'UuidDecoder',
    components: {
        Breadcrumb
    },
    data() {
        return {
            ip: null,
            domainName: null,
            history: [],
            showFailureMessage: false,
            submitting: false,
            errors: []
        }
    },
    mounted() {
    },
    computed: {},
    validations: {
        ip: { required, ipAddress },
        domainName: { required },
    },
    methods: {
        getIpHistory: function () {
            this.showFailureMessage = false;
            this.$v.ip.$touch();
            if (this.$v.ip.$invalid) return;
            this.submitting = true;
            ToolsService.getIpHistory(this.ip).then(response => {
                if (response.status === 200) {
                    this.history = response.data.history;
                } else {
                    this.errors = response.data.error;
                    this.showFailureMessage = true;
                }
                this.submitting = false;
            }).catch(error => {
                this.submitting = false;
                Swal({
                    type: 'error',
                    title: 'Oops...',
                    text: `${error}`,
                })
            });
        },
        getDomainNameHistory: function () {
            this.showFailureMessage = false;
            this.$v.domainName.$touch();
            if (this.$v.domainName.$invalid) return;
            this.submitting = true;
            ToolsService.getDomainNameHistory(this.domainName).then(response => {
                if (response.status === 200) {
                    this.history = response.data.history;
                } else {
                    this.errors = response.data.error;
                    this.showFailureMessage = true;
                }
                this.submitting = false;
            }).catch(error => {
                this.submitting = false;
                Swal({
                    type: 'error',
                    title: 'Oops...',
                    text: `${error}`,
                })
            });
        },
    }
}
</script>

<style scoped></style>